import configAccount from "Assets/newicons/config-dashboard/account/config-account.svg";
import accountBranding from "Assets/newicons/config-dashboard/account/palette1.svg";
import accountDetails from "Assets/newicons/config-dashboard/account/key.svg";
import accountEmail from "Assets/newicons/config-dashboard/account/send.svg";
import accountOffices from "Assets/newicons/config-dashboard/account/office.svg";
import accountLoginImg from "Assets/newicons/config-dashboard/account/login.jpg";
import accountOfficeImg from "Assets/newicons/config-dashboard/account/office-img.svg";
import accountDetailsImg from "Assets/newicons/config-dashboard/account/inc-deets.svg";
import accountEmailImg from "Assets/newicons/config-dashboard/account/email.jpg";

import configHrisCompany from "Assets/newicons/config-dashboard/hris/config-hris1.svg";
import configHrisEmployee from "Assets/newicons/config-dashboard/hris/config-hris2.svg";
import hrisBu from "Assets/newicons/config-dashboard/hris/config-hris-bu.svg";
import hrisDept from "Assets/newicons/config-dashboard/hris/config-hris-department.svg";
import hrisDes from "Assets/newicons/config-dashboard/hris/config-hris-designation.svg";
import hrisWorkflow from "Assets/newicons/config-dashboard/hris/config-hris-workflow.svg";
import hrisExit from "Assets/newicons/config-dashboard/hris/config-hris-exit-policy.svg";
import hrisProbation from "Assets/newicons/config-dashboard/hris/config-hris-probation.svg";
import flashIcon from "Assets/Svg/camera-flash.svg";
import BuImage from "Assets/newicons/config-dashboard/hris/config-bu-illustration.svg";
import deptImage from "Assets/newicons/config-dashboard/hris/config-department-illustration.svg";
import desImage from "Assets/newicons/config-dashboard/hris/config-designation-illustration.svg";
import approvalImage from "Assets/newicons/config-dashboard/hris/config-approval-illustration.svg";
import exitImage from "Assets/newicons/config-dashboard/hris/config-exit-policy-illustration.svg";
import probationImage from "Assets/newicons/config-dashboard/hris/config-probation-illustration.svg";
import teamImage from "Assets/newicons/config-dashboard/hris/config-teams-illustration.svg";
import customImage from "Assets/newicons/config-dashboard/hris/config-custom-fields-illustration.jpg";

export const CONFIG_DATA = [
  {
    sectionid: 0,
    sectionname: "company",
    sectionicon: configHrisCompany,
    sectiontitle: "Help us understand you company better",
    showtext: true,
    issuperpowers: true,
    subsection: [
      {
        subsectiontitle: "Add your business units",
        icon: hrisBu,
        duration: "3 min",
        superpowerid: 0,
        superpower: true,
        description:
          "As companies expand, business units are created to help strategize and organize the team. We won't get in the way of that.Easily add your business units here to later assign employees to",
        image: BuImage,

        steps: [
          {
            value: 1,
            text: "Navigate to Business Unit",
            url: "/config/hris/company/business_unit",
            note:
              "Note: You will be able to see your business units here, once created.",
          },
          { value: 2, text: "Click 'Create' in the top right", note: "" },
          {
            value: 3,
            text: "Fill out details to setup your business unit as desired.",
            note: "",
          },
          { value: 4, text: "Click save", note: "" },
          {
            value: 5,
            text:
              "Success message will signify completion of task, else an error message will point towards mistakes to fix.",
            note: "",
          },
          {
            value: 6,
            text:
              "Create all your Business Units one at a time by following the same steps.",
            note: "",
          },
        ],
      },
      {
        subsectiontitle: "Add your departments",
        icon: hrisDept,
        duration: "2 min",
        superpowerid: 0,
        superpower: true,
        description:
          "Each department functions differently, and that's where the power lies. We understand that allow you to filter and configure based on departments once you have created them here.Easily add your departments here to later assign employees to.",
        image: deptImage,
        steps: [
          {
            value: 1,
            text: "Navigate to Department",
            url: "/config/hris/company/department",
            note:
              "Note: You will be able to see your departments here, once created.",
          },
          { value: 2, text: "Click 'Create' in the top right", note: "" },
          {
            value: 3,
            text: "Fill out details to set up your department as desired.",
            note: "",
          },
          { value: 4, text: "Click save", note: "" },
          {
            value: 5,
            text:
              "Success message will signify completion of task, else an error message will point towards mistakes to fix.",
            note: "",
          },
          {
            value: 6,
            text:
              "Create all your departments one at a time by following the same steps.",
            note: "",
          },
        ],
      },
      {
        subsectiontitle: "Add all employee designations",
        icon: hrisDes,
        duration: "2 min",
        superpowerid: 0,
        superpower: true,
        description:
          "Employee designations are add on to the further flexibility of business units and departments.Easily add all designations here to later assign to your employees.",
        image: desImage,
        steps: [
          {
            value: 1,
            text: "Navigate to Designation",
            url: "/config/hris/company/designation",
            note:
              "Note: You will be able to see all designations here, once created.",
          },
          { value: 2, text: "Click 'Create' in the top right", note: "" },
          {
            value: 3,
            text:
              "Fill out details and navigate through the steps to provide all required info.",
            note: "",
          },
          {
            value: 4,
            text: "Upon reaching the end of the form, click save.",
            note: "",
          },
          {
            value: 5,
            text:
              "Success message will signify completion of task, else an error message will point towards mistakes to fix.",
            note: "",
          },
          {
            value: 6,
            text:
              "Create all required designations one at a time by following the same steps.",
            note: "",
          },
        ],
      },

      {
        subsectiontitle: "Create teams for your employees",
        icon: flashIcon,
        duration: "3 min",
        superpowerid: 1,
        superpower: false,
        description:
          "There's no doubt we are stronger as a team. Create and organize your teams on sumHR to allow for easy management.Super power your workplace by creating teams and assigning team leaders.",
        image: teamImage,
        steps: [
          {
            value: 1,
            text: "Navigate to Team",
            url: "/config/hris/company/team",
            note: "Note: You will be able to see all teams here once created.",
          },
          { value: 2, text: "Click 'Create' in the top right", note: "" },
          {
            value: 3,
            text: "Fill out details to set up team.",
            note: "",
          },
          {
            value: 4,
            text: "Click 'Save'",
            note: "",
          },
          {
            value: 5,
            text:
              "Success message will signify completion of task, else an error message will point towards mistakes to fix.",
            note: "",
          },
          {
            value: 6,
            text: "Create all teams one at a time by following the same steps.",
            note: "",
          },
        ],
      },
    ],
  },
  {
    sectionid: 2,
    sectionname: "employee",
    sectionicon: configHrisEmployee,
    sectiontitle: "In between hello's and goodbye's",
    showtext: true,
    issuperpowers: true,
    subsection: [
      {
        subsectiontitle: "Set up approval workflow",
        icon: hrisWorkflow,
        duration: "10 min",
        superpowerid: 0,
        superpower: true,
        description:
          "It's important that the right people are informed and involved in the approval process. Multiple workflows can be created and then assigned to groups of employees as required.In this step, you will create approval workflows and then go on to assign them to your employees.",
        image: approvalImage,
        steps: [
          {
            value: 1,
            text: "Navigate to Approval Workflow",
            url: "/config/hris/employee/approval_workflow",
            note:
              "Note: You will be able to see all approval workflows here, once created.",
          },
          { value: 2, text: "Click 'Create' in the top right", note: "" },
          {
            value: 3,
            text:
              "Provide a name and description of the workflow you're creating.",
            note: "",
          },
          {
            value: 4,
            text:
              "Go through the steps to define or skip workflows as required.",
            note:
              "Note: You do not have to define rules for each type of workflow.",
          },
          {
            value: 5,
            text: "Once you reach the last step, click 'Save'.",
            note: "",
          },
          {
            value: 6,
            text:
              "Success message will signify completion of task, else an error message will point towards mistakes to fix.",
            note: "",
          },
          {
            value: 7,
            text:
              "Create all approval workflows one at a time by following the same steps.",
            note: "",
          },
          {
            value: 8,
            text: "Assign approval workflow",
            note: "",
          },
          {
            value: 9,
            text: "Navigate to Approval Workflow Planner",
            note: "",
          },
          {
            value: 10,
            text:
              "Double click on the blank space below 'Approval Workflow' for each employee to open assignment menu.",
            note:
              "You may also bulk assign policies by clicking on the button 'Bulk Assign' at the top.",
          },
          {
            value: 11,
            text: "Select policy from the dropdown menu",
            note: "",
          },
          {
            value: 12,
            text:
              "Go through the steps one at a time for each employee to assign required policies.",
            note:
              "You may filter the employees by using the tool in the top right labeled 'Filter'.",
          },
          {
            value: 13,
            text: "Click 'Preview Changes' in the top right.",
            note: "",
          },
          {
            value: 14,
            text: "Click 'Save' after reviewing assigned policies",
            note: "",
          },
        ],
      },

      {
        subsectiontitle: "Set up probation guidelines",
        icon: hrisProbation,
        duration: "2 min",
        superpowerid: 0,
        superpower: true,
        description:
          "New additions to the team call for celebrations, but often we get swamped in probation guidelines and dates. Set up your probation rules and let sumHR remind you when the time is right.In this step, create probation guidelines and customize dates as your workspace demands.",
        image: probationImage,
        steps: [
          {
            value: 1,
            text: "Navigate to Probation",
            url: "/config/hris/employee/probation",
            note:
              "Note: You will be able to see all probations here once created.",
          },
          { value: 2, text: "Click 'Create' in the top right", note: "" },
          {
            value: 3,
            text:
              "Fill out details and navigate through the steps to provide all required info.",
            note: "",
          },
          {
            value: 4,
            text: "Upon reaching the end of the form, click save.",
            note: "",
          },
          {
            value: 5,
            text:
              "Success message will signify completion of task, else an error message will point towards mistakes to fix.",
            note: "",
          },
          {
            value: 6,
            text:
              "Create all required probation policies one at a time by following the same steps.",
            note: "",
          },
        ],
      },
      {
        subsectiontitle: "Create a clear exit policy",
        icon: hrisExit,
        duration: "1 min",
        superpowerid: 0,
        superpower: true,
        description:
          "Saying goodbyes are difficult, but often for the wrong reasons. sumHR allows for transparent communication and clear guidelines, so you only have to worry about the tissue boxes.Go ahead and create exit policies with control over notice periods, self resignation and manager approval.",
        image: exitImage,
        steps: [
          {
            value: 1,
            text: "Navigate to Exit Policy",
            url: "/config/hris/employee/exit_policy",
            note:
              "Note: You will be able to see all exit policies here once created.",
          },
          { value: 2, text: "Click 'Create' in the top right", note: "" },
          {
            value: 3,
            text:
              "Fill out details and navigate through the steps to provide all required info.",
            note: "",
          },
          {
            value: 4,
            text: "Upon reaching the end of the form, click save.",
            note: "",
          },
          {
            value: 5,
            text:
              "Success message will signify completion of task, else an error message will point towards mistakes to fix.",
            note: "",
          },
          {
            value: 6,
            text:
              "Create all required exit policies one at a time by following the same steps.",
            note: "",
          },
        ],
      },
      {
        subsectiontitle: "Superpower your data with custom fields",
        icon: flashIcon,
        duration: "2 min",
        superpowerid: 1,
        superpower: false,
        description:
          "Although sumHR provides a detailed set of data points for your employees to fill, we empower you to create personalized data fields to suit your needs.Super power your HRMS by creating custom data fields for your employee's profile section.",
        image: customImage,
        steps: [
          {
            value: 1,
            text: "Navigate to Custom Data",
            url: "/config/hris/employee/custom_data",
            note:
              "Note: You will be able to see all custom fields here and take actions once created.",
          },
          { value: 2, text: "Click 'Create' in the top right", note: "" },
          {
            value: 3,
            text:
              "Fill out details and navigate through the steps to provide all required info.",
            note: "",
          },
          {
            value: 4,
            text: "Upon reaching the end of the form, click save.",
            note: "",
          },
          {
            value: 5,
            text:
              "Success message will signify completion of task, else an error message will point towards mistakes to fix.",
            note: "",
          },
          {
            value: 6,
            text:
              "Create all required custom fields one at a time by following the same steps.",
            note: "",
          },
        ],
      },
    ],
  },
  {
    sectionid: 5,
    sectionname: "account",
    sectionicon: configAccount,
    sectiontitle: "Set up your branding on sumHR",
    showtext: true,
    issuperpowers: false,
    subsection: [
      {
        subsectiontitle: "Design your login page",
        icon: accountBranding,
        duration: "5 min",
        superpowerid: 0,
        superpower: true,
        description:
          "Your login page is the face of your HRMS for all your employees. Let's make it truly yours! You will be able to a welcome image, friendly intro and a favicon to truly make employees feel welcome.",
        image: accountLoginImg,
        steps: [
          {
            value: 1,
            text: "Navigate to Interface Branding",
            url: "/config/hris/account_management/interface_branding",
            note: "",
          },
          {
            value: 2,
            text: "Upload necessary files for welcome image and favicon.",
            note: "Note: Supported file types are png and jpg.",
          },
          {
            value: 3,
            text: "Insert fun welcome header and description.",
            note: "",
          },
          {
            value: 4,
            text: "Click save",
            note: "",
          },
          {
            value: 5,
            text:
              "Success message will signify completion of task, else an error message will point towards mistakes to fix.",
            note: "",
          },
        ],
      },

      {
        subsectiontitle: "Set up email branding",
        icon: accountEmail,
        duration: "1 min",
        superpowerid: 0,
        superpower: true,
        description:
          "We send automated emails to your employees to keep everyone well informed. The emails are automated, but they don't have to feel robotic.In this step, you will be able to customize the email sender details such as name, reply to email and even a fancy signature.",
        image: accountEmailImg,
        steps: [
          {
            value: 1,
            text: "Navigate to Email Branding",
            url: "/config/hris/account_management/email_branding",
            note:
              "Note: You will be able to see all probations here once created.",
          },
          { value: 2, text: " Fill out sender details as desired.", note: "" },
          {
            value: 3,
            text: "Click save",
            note: "",
          },
          {
            value: 4,
            text:
              "Success message will signify completion of task, else an error message will point towards mistakes to fix.",
            note: "",
          },
        ],
      },
      {
        subsectiontitle: "Add all your offices",
        icon: accountOffices,
        duration: "5 min",
        superpowerid: 0,
        superpower: true,
        description:
          "Offices are where the magic happens, and it's important for us to keep track of all of them so we can assign them to employees.You can add as many offices as you have, that's all that you have to do in this task.",
        image: accountOfficeImg,
        steps: [
          {
            value: 1,
            text: "Navigate to Company Offices",
            url: "/config/hris/account_management/company_offices",
            note:
              "Note: You will be able to see your company offices here, once created.",
          },
          { value: 2, text: "Click 'Add office' in the top right", note: "" },
          {
            value: 3,
            text: "Fill out details of your office location",
            note: "",
          },
          {
            value: 4,
            text: "Click save",
            note: "",
          },
          {
            value: 5,
            text:
              "Success message will signify completion of task, else an error message will point towards mistakes to fix.",
            note: "",
          },
          {
            value: 6,
            text:
              "Add all your offices one at a time by following the same steps.",
            note: "",
          },
        ],
      },
      {
        subsectiontitle: "Store your incorporation details for safekeeping",
        icon: accountDetails,
        duration: "2 min",
        superpowerid: 0,
        superpower: true,
        description:
          "Incorporation details are useful through the HR domain. It'll be helpful to keep them stored safely here as well.Just store them here once, and you don't have to look them up again whether it's for payroll or referencing in a policy.",
        image: accountDetailsImg,
        steps: [
          {
            value: 1,
            text: "Navigate to Incorporation Details",
            url: "/config/hris/account_management/incorporation_details",
            note: "",
          },
          {
            value: 2,
            text: "Fill incorporation details as indicated",
            note: "",
          },
          {
            value: 3,
            text: "Click save",
            note: "",
          },
          {
            value: 4,
            text:
              "Success message will signify completion of task, else an error message will point towards mistakes to fix.",
            note: "",
          },
        ],
      },
    ],
  },
];
